import React from 'react';
export function Footer() {
  return <div className="footer" data-id="element-68">
      © 2026 Sharon Tirado · Infinia · Todos los derechos reservados
    </div>;
}